import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link as RouterLink } from 'react-router-dom';

import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/CheckCircle';
import DocumentIcon from '@material-ui/icons/InsertDriveFile';
import Paper from '@material-ui/core/Paper';

import Icon from '@components/Icon/Icon';

import './MainDetails.scss';
import '@components/Link/Link';

const MainDetails = ({
  caseId,
  claimId,
  data: {
    amendsClaim,
    amendsClaimDateFiled,
    basisForClaim,
    claimNumber,
    dateFiled,
    debtor,
    isContingent,
    isDisputed,
    isObjected,
    isObjectionResolved,
    isUnliquidated,
    objectionBasis,
    relatedClaimsFiled,
    relatedDocs,
    relatedSchedule,
    schedule,
    status,
    typeOfClaim,
  },
}) => (
  <Paper className="main-details">
    <div className="main-details__header">
      Claim details
    </div>
    <div className="main-details__content">
      <div className="main-details__link-wrapper">
        <RouterLink
          to={`/cases/${caseId}/claims`}
          className="link main-details__link"
        >
          &lt; Back to search results
        </RouterLink>
      </div>
      <div className="main-details__title">
        <div className="main-details__title-label">
          Debtor:
        </div>
        <div className="main-details__title-value">
          {debtor}
        </div>
      </div>
      <div className="main-details__category">
        {claimNumber && (
          <div className="main-details__group">
            <div className="main-details__label">
              Claim number:
            </div>
            <div className="main-details__value">
              {claimNumber}
            </div>
          </div>
        )}
        {schedule && schedule.scheduleNumber && (
          <div className="main-details__group">
            <div className="main-details__label">
              Schedule number:
            </div>
            <div className="main-details__value">
              {schedule.scheduleNumber}
            </div>
          </div>
        )}
        {dateFiled && (
          <div className="main-details__group">
            <div className="main-details__label">
              Date filed:
            </div>
            <div className="main-details__value">
              {moment(dateFiled).format('L')}
            </div>
          </div>
        )}
        {status && (
          <div className="main-details__group">
            <div className="main-details__label">
              Status:
            </div>
            <div className="main-details__value">
              {status}
            </div>
          </div>
        )}
        {amendsClaim && (
          <div className="main-details__group">
            <div className="main-details__label">
              Amends claim number:
            </div>
            <div className="main-details__value">
              {amendsClaim}
            </div>
          </div>
        )}
        {amendsClaimDateFiled && (
          <div className="main-details__group">
            <div className="main-details__label">
              Amends claim filed on:
            </div>
            <div className="main-details__value">
              {moment(amendsClaimDateFiled).format('L')}
            </div>
          </div>
        )}
        {relatedSchedule && (
          <div className="main-details__group">
            <div className="main-details__label">
              Schedule number:
            </div>
            <div className="main-details__value">
              {relatedSchedule}
            </div>
          </div>
        )}
        {relatedClaimsFiled > 0 && (
          <div className="main-details__group">
            <div className="main-details__label">
              Related claims filed:
            </div>
            <div className="main-details__value">
              {relatedClaimsFiled}
            </div>
          </div>
        )}
        {basisForClaim && (
          <div className="main-details__group">
            <div className="main-details__label">
              Basis of claim:
            </div>
            <div className="main-details__value">
              {basisForClaim}
            </div>
          </div>
        )}
        {typeOfClaim && (
          <div className="main-details__group">
            <div className="main-details__label">
              Type of claim:
            </div>
            <div className="main-details__value">
              {typeOfClaim}
            </div>
          </div>
        )}
      </div>
      <div className="main-details__category">
        <div className="main-details__group main-details__group--centered">
          <div className="main-details__label">
            Contingent:
          </div>
          <div className="main-details__value">
            <Icon>
              {isContingent
                ? <CheckIcon />
                : <CancelIcon />
              }
            </Icon>
          </div>
        </div>
        <div className="main-details__group main-details__group--centered">
          <div className="main-details__label">
            Unliquidated:
          </div>
          <div className="main-details__value">
            <Icon>
              {isUnliquidated
                ? <CheckIcon />
                : <CancelIcon />
              }
            </Icon>
          </div>
        </div>
        <div className="main-details__group main-details__group--centered">
          <div className="main-details__label">
            Disputed:
          </div>
          <div className="main-details__value">
            <Icon>
              {isDisputed
                ? <CheckIcon />
                : <CancelIcon />
              }
            </Icon>
          </div>
        </div>
        <div className="main-details__group main-details__group--centered">
          <div className="main-details__label">
            Objected:
          </div>
          <div className="main-details__value">
            <Icon>
              {isObjected
                ? <CheckIcon />
                : <CancelIcon />
              }
            </Icon>
          </div>
        </div>
        <div className="main-details__group main-details__group--centered">
          <div className="main-details__label">
            Objection resolved:
          </div>
          <div className="main-details__value">
            <Icon>
              {isObjectionResolved
                ? <CheckIcon />
                : <CancelIcon />
              }
            </Icon>
          </div>
        </div>
        {objectionBasis && (
          <div className="main-details__group">
            <div className="main-details__label">
              Objection basis:
            </div>
            <div className="main-details__value">
              {objectionBasis}
            </div>
          </div>
        )}
      </div>
    </div>
    {relatedDocs > 0 && (
      <div className="main-details__dockets-link-wrapper">
        <RouterLink
          to={`/cases/${caseId}/dockets?claimId=${claimId}`}
          className="link"
        >
          <div className="main-details__dockets-link-button">
            <Icon className="main-details__dockets-link-icon">
              <DocumentIcon />
            </Icon>
            Related dockets: {relatedDocs}
          </div>
        </RouterLink>
      </div>
    )}
  </Paper>
);

MainDetails.propTypes = {
  caseId: PropTypes.string.isRequired,
  claimId: PropTypes.string.isRequired,
  data: PropTypes.shape({
    amendsClaim: PropTypes.number,
    amendsClaimDateFiled: PropTypes.string,
    basisForClaim: PropTypes.string,
    claimNumber: PropTypes.string,
    dateFiled: PropTypes.string,
    debtor: PropTypes.string,
    id: PropTypes.number,
    isContingent: PropTypes.bool,
    isDisputed: PropTypes.bool,
    isObjected: PropTypes.bool,
    isObjectionResolved: PropTypes.bool,
    isUnliquidated: PropTypes.bool,
    objectionBasis: PropTypes.string,
    relatedClaimsFiled: PropTypes.number,
    relatedDocs: PropTypes.number,
    relatedSchedule: PropTypes.number,
    schedule: PropTypes.object,
    status: PropTypes.string,
    typeOfClaim: PropTypes.string,
  }).isRequired,
};

export default MainDetails;



// WEBPACK FOOTER //
// ./src/routes/Case/Claims/ClaimDetails/components/MainDetails/MainDetails.js